import { POC_MNG } from '@/api'
import { PLAN_MNG } from '@/api/apiModules'

import lang from '@/lang'
import dictionary from '@/utils/dictionary'
export default {
  viewType: 'table',
  module: POC_MNG,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  params: {
    isTemplate: false
  },
  refreshInterval: 20000,
  // relationSearch: true,
  cb: function() {},
  allowStatus: {
    //设置按钮权限
    SetPocProjectTemplate: {
      expression: function(row) {
        return this.$store.getters.baseInfo.hasSuperPrivilege === true && row.flowStatus === 'CREATE_ORDER'
      }
    },
    CopyPocProject: {
      expression: function(row) {
        return row.flowStatus === 'CREATE_ORDER'
      }
    },
    SetRequestConfirm: {
      expression: function(row) {
        return (
          (this.$store.getters.baseInfo.hasSuperPrivilege === true || row.postSales) &&
          row.flowStatus === 'CREATE_ORDER'
        )
      }
    }
  },

  toolbar: {
    searchWidth: 380,
    moreBtnWidth: 160,
    // hasColAdjustment: true,
    searchPlaceholder: 'pocMng.searchPlaceholder',
    searchFieldNameArr: ['customer', 'projectName', 'projectCode', 'createUserName'],
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'pocMng.btns.createPocProject',
        props: {
          disabled: false,
          type: 'primary',
          icon: 'el-icon-plus'
        },
        tip: 'pocMng.tips.createPocProject',
        action: 'CreatePocDetailProject'
      },
      {
        slot: 'refresh-rigtht',
        label: 'pocMng.btns.createProjectFromTemplate',
        props: {
          disabled: false,
          type: 'primary',
          icon: 'el-icon-plus'
        },
        tip: 'pocMng.tips.createProjectFromTemplate',
        action: 'CreatePocProjectFromTemplate'
      }
    ]
  },
  class: 'sk-custom-table-right-page',
  view: {
    'cell-class-name': 'sk-customize-cell-hight',
    columns: [
      // {
      //   props: {
      //     label: 'pocMng.projectNumber',
      //     prop: 'projectCode',
      //     width: 105
      //   }
      // },
      {
        props: {
          label: 'pocMng.projectName',
          prop: 'projectName',
          sortField: 'projectName',
          'min-width': 260
        },
        dataType: 'link',
        action: 'ShowProjectOverviewForTableList'
      },
      {
        props: {
          label: 'pocMng.customer',
          prop: 'customer',
          sortField: 'customer',
          width: 255
        }
      },
      {
        props: {
          label: 'pocMng.industry',
          prop: 'industryId',
          width: 110
        },
        dataType: 'custom',
        custom(row, _h, value, e) {
          return row.industryName
        },
        filter: true,
        url: `industry/list`,
        params: {
          limit: 100,
          page: 0
        }
      },
      {
        props: {
          label: 'pocMng.sales',
          prop: 'salesName',
          sortField: 'salesName',
          width: 80
        }
      },
      {
        props: {
          label: 'pocMng.presales',
          prop: 'presalesName',
          sortField: 'presalesName',
          width: 80
        }
      },
      {
        props: {
          label: 'pocMng.postsales',
          prop: 'postsalesName',
          sortField: 'postsalesName',
          width: 90
        },
        dataType: 'custom',
        custom: function(row, h, value, e) {
          if (!row.postsalesIdLabelList) {
            return ''
          }
          const nameArr = row.postsalesIdLabelList.map(item => item.label).join(', ')
          return <span>{nameArr}</span>
        }
      },
      {
        props: {
          label: 'pocMng.extensionIds',
          prop: 'extensionName',
          width: 90
        },
        dataType: 'custom',
        custom: function(row, h, value, e) {
          if (!row.extensionIdLabelList) {
            return ''
          }
          const nameArr = row.extensionIdLabelList.map(item => item.label).join(', ')
          return <span>{nameArr}</span>
        }
      },
      {
        props: {
          label: 'pocMng.pocState',
          prop: 'flowStatus',
          sortField: 'flowStatus',
          width: 140
        },
        filter: true,
        dataType: 'custom',
        custom: function(data, h) {
          if (!data) {
            return
          }
          if (dictionary['flowStatus'][data.flowStatus].type) {
            const renderItem = [
              <el-tag type={dictionary['flowStatus'][data.flowStatus].type}>
                {lang.t(dictionary['flowStatus'][data.flowStatus].label)}
              </el-tag>
            ]
            return renderItem
          } else {
            const renderItem = [
              <el-tag color={dictionary['flowStatus'][data.flowStatus].color}>
                {lang.t(dictionary['flowStatus'][data.flowStatus].label)}
              </el-tag>
            ]
            return renderItem
          }
        }
      },
      {
        props: {
          label: 'pocMng.projectSourceType',
          prop: 'projectSourceType',
          sortField: 'projectSourceType',
          width: 110
        },
        filter: true,
        dataType: 'enum',
        dictionaryPath: 'projectSourceType'
      },
      {
        props: {
          label: 'pocMng.createTime',
          prop: 'createTime',
          sortable: 'custom',
          sortField: 'createTime',
          width: 120
        },
        //dataType: 'date'
        dataType: 'custom',
        custom: function(row, h, value, e) {
          var date = new Date(value)
          var Y = date.getFullYear() + '-'
          var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
          var D = date.getDate() + 1 > 10 ? date.getDate() : '0' + date.getDate()
          return <span>{Y + M + D}</span>
        }
      },
      {
        props: {
          label: 'pocMng.createUserName',
          prop: 'createUserName',
          sortField: 'createUserName',
          width: 105
        }
      },
      {
        props: {
          label: 'pocMng.projectPlan',
          prop: 'planFlag',
          width: 90
        },
        dataType: 'custom',
        custom: function(data, h) {
          if (!data) {
            return
          }

          let vNode = [
            <div class="wsp-display-flex-center">
              <div class="wsp-width-20 el-icon-download"></div>
              <div class="wsp-width-80">
                <div
                  class="sk-link--normal  wsp-width-100"
                  on-click={$event => {
                    this.$store.dispatch('customDownloadDocument', {
                      module: PLAN_MNG,
                      params: {
                        id: data.id
                      },
                      action: 'downloadPlan'
                    })
                  }}
                >
                  <span>Word</span>
                </div>
                <div
                  class="sk-link--normal wsp-width-100"
                  on-click={$event => {
                    this.$store.dispatch('customDownloadDocument', {
                      module: PLAN_MNG,
                      params: {
                        id: data.id
                      },
                      action: 'downloadPlanExcel'
                    })
                  }}
                >
                  <span>Excel</span>
                </div>
              </div>
            </div>
          ]

          if (data.planFlag === 'Y') {
            return vNode
          }
          if (data.planFlag === 'N') {
            if (data.flowStatus == 'CREATE_ORDER' && data.industryCode === 'YYS') {
              let url = 'https://ruijie.feishu.cn/sheets/LejrskSi6hZe69ttaiXcBQCAnFb'
              return [
                <div
                  class="sk-link--normal"
                  title="请根据方案指导内容输出测试方案"
                  on-click={$event => {
                    window.open(url, '_blank')
                  }}
                >
                  <span>方案指导</span>
                </div>
              ]
            } else {
              return <span>未生成</span>
            }
          }
          return
        }
      },
      {
        //操作
        props: {
          showBtnNum: '2',
          fixed: null
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: 'pocMng.btns.deal',
        command: 'ShowPocProjectDetail',
        name: 'ShowPocProjectDetail'
      },
      // {
      //   icon: 'el-icon-edit',
      //   label: 'pocMng.btns.edit',
      //   command: 'EditProTestProjectBaseInfo',
      //   name: 'EditProTestProjectBaseInfo'
      // },
      {
        icon: 'el-icon-plus',
        label: 'pocMng.btns.copy',
        command: 'CopyPocProject',
        name: 'CopyPocProject',
        tip: '未到创建工单步骤无法操作复制'
      },
      {
        icon: 'el-icon-delete',
        label: 'delete',
        command: 'UmDeleteUser',
        name: 'umDeleteUser',
        confirm: {
          grade: 0,
          msg: 'pocMng.tips.deletePocProject'
        }
      },
      {
        icon: 'el-icon-edit',
        label: 'pocMng.btns.setTemplate',
        command: 'SetPocProjectTemplate',
        name: 'SetPocProjectTemplate',
        tip: '非管理员无法操作'
      },
      {
        icon: 'el-icon-edit',
        label: 'pocMng.btns.requestConfirm',
        command: 'SetRequestConfirm',
        name: 'SetRequestConfirm',
        tip: '非售后人员与创建工单步骤无法操作'
      }
    ]
  }
}
